import React from 'react'
import { Block, VideoWithContent } from '@components'

const DatoCmsVideoWithContent = ({
  paddingTop,
  paddingBottom,
  background,
  backgroundStyle,
  ...props
}) => {
  return (
    <Block
      gutters={props.width !== 'Full Width'}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      background={background}
      backgroundStyle={backgroundStyle}
    >
      <VideoWithContent elevated {...props} />
    </Block>
  )
}

export default DatoCmsVideoWithContent
